import _ from 'lodash'
import MultiChoiceFilter from 'scoreboard/reports/common/filter/multichoice-filter'
import template from 'scoreboard/reports/common/filter/multichoice-filter.hbs'
import enums from 'scoreboard/components/enums'
import i18n from 'scoreboard/components/i18n'
import prettyJoin from 'scoreboard/reports/common/filter/pretty-joiner'
import license from 'scoreboard/components/license'
import currency from 'scoreboard/components/currency'

function meta(code, choices, formOptions = {}) {
	return {
		nameCode: code,
		filterType: 'multichoice',
		form: MultiChoiceFilter,
		formOptions,
		choices: choices,
		template: template,
		dialogType: 'dark',
		pluralLabel: () => formOptions.pluralCode ?
			i18n.get(formOptions.pluralCode) : null,
		stringify: function(data) {
			var values = _.map(data.values, function(val) { return i18n.get(choices()[val]) })
			return i18n.get('report.filter.pretty.multichoice', prettyJoin(values))
		},
		groupCode: 'admin.scorecards.metric.scoringType.basic'
	}
}

var MultiChoiceFilterMeta = {
	currency: meta('common.currency', () => currency.labelsByCode(),
		{ pluralCode: 'common.currencies' }),
	types: meta('report.customReport.subtype', function() {
		return enums.scorecardItemType
	}, { pluralCode: 'report.customReport.subtypes' }),
	dataTypes: meta('report.customReport.metricDataType', function() {
		return enums.scorecardItemDataType
	}, { pluralCode: 'scorecards.node.metric.dataType.dataTypes' }),
	updateTypes: meta('report.customReport.metricUpdateType', function() {
		let types = enums.updateType
		if (!license['datasets']) {
			types = _.omit(types, 'dataset')
		}
		return types
	}, { pluralCode: 'report.customReport.metricUpdateTypes' }),
	aggregationTypes: meta('report.customReport.aggregationType', function() {
		return enums.scorecardItemAggregationType
	}, { pluralCode: 'report.customReport.aggregationTypes' }),
	rollupAggregationTypes: meta('scorecards.node.metric.aggregationType.aggregationType.rollup', () =>
		_.omit(enums.scorecardItemAggregationType, 'last-value', 'use-equation'),
		{ pluralCode: 'report.customReport.aggregationTypes' }),
	missingValueTreatments: meta('report.customReport.missingValueTreatment', _.memoize(() => {
		return enums.missingValueTreatment
	}), {
		handleNullValue: () => { return 'null' },
		pluralCode: 'scorecards.node.metric.missingValuesTreatments'
	})
}

export default MultiChoiceFilterMeta
export const multiChoiceMeta = meta

MultiChoiceFilterMeta.__filename__ = 'reports/wizard/filter-meta/multichoice.js'
